







































































import Vue, { PropOptions } from 'vue';
import parts from '@/parts';
import * as TypeVariable from '@/parts/VariableInput.vue';
// import TopBar from '@/components/TopBar.vue';
import * as PClass from '@/class';
import * as Models from '@/class/models/views';

const MODE_LOGIN = 'login';
const MODE_SIGNUP = 'signup';
const MODE_SETPASSWORD = 'setPassword';
const MODE_REGISTER = 'register';
const MODE_FORGET = 'forget';
const MODE_FORGET_CONFIRM = 'confirm';

export default Vue.extend({
  name: 'LoginMenu',
  components: {
    ...parts,
  },
  data() {
    return {
      loginFlag: false,
      mode: '',
      inputData: new Models.CAuth(),
      inputConfirmData: new Models.CConfirm(),
      items: [
        {key: 'id', name: '', type: TypeVariable.INPUT_TYPE.TEXT, required: true, error: '', max: 99},
        {key: 'password', name: '', type: TypeVariable.INPUT_TYPE.PASSWORD, required: true, error: '', max: 99},
        {key: 'confirmPassword', name: '', type: TypeVariable.INPUT_TYPE.PASSWORD, required: true, error: '', max: 99},
      ] as TypeVariable.IVariableInput[],
      itemsConfirm: [
        {key: 'code', name: '', type: TypeVariable.INPUT_TYPE.TEXT, required: true, error: '', max: 99},
        {key: 'mail', name: '', type: TypeVariable.INPUT_TYPE.TEXT, required: true, error: '', max: 99},
        {key: 'password', name: '', type: TypeVariable.INPUT_TYPE.PASSWORD, required: true, error: '', max: 99},
      ] as TypeVariable.IVariableInput[],
    };
  },
  computed: {
    MODE_LOGIN(): string { return MODE_LOGIN; },
    MODE_SIGNUP(): string { return MODE_SIGNUP; },
    MODE_SETPASSWORD(): string { return MODE_SETPASSWORD; },
    MODE_FORGET(): string { return MODE_FORGET; },
    MODE_FORGET_CONFIRM(): string { return MODE_FORGET_CONFIRM; },
  },
  methods: {
    onClickShowLogin() {
      this.inputData = new Models.CAuth();
      this.mode = MODE_LOGIN;
    },
    onClickShowSignup() {
      this.inputData = new Models.CAuth();
      this.mode = MODE_SIGNUP;
    },
    onClickShowForget() {
      // this.inputConfirmData = new Models.CConfirm();
      this.mode = MODE_FORGET;
    },
    onClickShowForgetConfirm() {
      this.inputConfirmData = new Models.CConfirm();
      this.mode = MODE_FORGET_CONFIRM;
    },
    async onClickLogin() {
      this.$emit('login', this.inputData);
    },
    async onClickSignup() {
      this.items[0].error = '';

      // API
      const api = new PClass.API();
      const res = await api.post<Models.IAuth, Models.IAuth>('auth/signup', this.inputData);
      // console.log(res);

      if (!res.result.error) {

        this.mode = MODE_SETPASSWORD;
        this.inputData.accessToken = res.data.accessToken;
        this.$emit('info', '大小英数字を1文字ずつ含んだ8文字以上のパスワードを設定してください。');
      } else {
        // this.$emit('info', res.result.message);
        this.$emit('errorInfo', res.result);
      }

    },
    async onClickConfirm() {
      this.items[1].error = '';
      this.items[2].error = '';
      if (this.inputData.password.length <= 7) {
        this.$emit('info', '大小英数字を1文字ずつ含んだ8文字以上のパスワードを設定してください。');
        return;
      }
      if (this.inputData.password !== this.inputData.confirmPassword) {
        this.items[2].error = '確認用のパスワードが一致しません';
        return;
      }
      // API
      const api = new PClass.API();
      const res = await api.post<Models.IAuth, Models.IAuth>('auth/confirm', this.inputData);
      // console.log(res);

      if (!res.result.error) {
        // 成功時
        const mail = this.inputData.mail
        this.inputData = new Models.CAuth();
        this.inputData.mail = mail;
        this.mode = MODE_LOGIN;
        this.$emit('info', '認証に成功しました。ログインしてください。');
      } else {
        // this.$emit('info', res.result.message);
        this.$emit('errorInfo', res.result);
      }

    },
    async onClickForget() {
      this.items[0].error = '';

      // API
      const api = new PClass.API();
      const res = await api.post<Models.IAuth, Models.IAuth>('auth/forget', this.inputData);
      // console.log(res);

      if (!res.result.error) {
        this.mode = MODE_FORGET_CONFIRM;
        // this.inputData.accessToken = res.data.accessToken;

      } else {
        this.$emit('errorInfo', res.result);
        // this.$emit('info', res.result.message);
      }
    },
    async onClickForgetConfirm() {
      this.itemsConfirm[0].error = '';
      this.itemsConfirm[1].error = '';
      this.itemsConfirm[2].error = '';

      // API
      const api = new PClass.API();
      const res = await api.post<Models.IConfirm, Models.IConfirm>('auth/confirm_forget', this.inputConfirmData);
      // console.log(res);

      if (!res.result.error) {
        // this.mode = MODE_SETPASSWORD;
        // this.inputData.accessToken = res.data.accessToken;
        this.onClickShowLogin();
        this.inputData.mail = this.inputConfirmData.mail;
        this.inputData.password = this.inputConfirmData.password;
        this.$emit('info', '認証に成功しました。ログインしてください。');
      } else {
        this.$emit('errorInfo', res.result);
        // this.$emit('info', res.result.message);
      }
    },
  },
});
